import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  type OfferV11,
  type PimProductWithVariantsV1,
} from '@redteclab/api/clients/bully'

import { Button } from 'base-ui'

import {
  type PublicGlobalConfig,
  useGlobalConfigContext,
} from '../../../../../global-config'
import {
  urlAddSearchParams,
  urlResolverGetPathForPimProduct,
} from '../../../../../url-handling'
import { useProductPageContext } from '../../../productPageContext'
import { useBuildAddToCartParams } from '../../ProductAddToCartGroup/ProductAddToCartCta/useBuildAddToCartParams'

type ProductOfferGoToProductCtaProps = { offer: OfferV11 }

const getProductUrlForSpecificOffer = ({
  offer,
  product,
  publicGlobalConfig,
}: {
  offer: OfferV11
  product: PimProductWithVariantsV1
  publicGlobalConfig: PublicGlobalConfig
}): string => {
  return urlAddSearchParams(
    urlResolverGetPathForPimProduct(publicGlobalConfig, product),
    { offerId: offer.offerId },
  )
}

export const ProductOfferGoToProductCta: FC<
  ProductOfferGoToProductCtaProps
> = ({ offer }) => {
  const { product } = useProductPageContext()
  const publicGlobalConfig = useGlobalConfigContext()
  const { addToCartParams } = useBuildAddToCartParams({ offer })

  if (addToCartParams) {
    // eslint-disable-next-line react-hooks/immutability -- don't reference, refactor if touched
    addToCartParams.eventName = 'addToCart_OfferItem'
  }

  return (
    <Button<'a'>
      color="secondary"
      href={getProductUrlForSpecificOffer({
        offer,
        product,
        publicGlobalConfig,
      })}
      size="small"
      slots={{ root: 'a' }}
    >
      <FormattedMessage id="productOffer.toOffer" />
    </Button>
  )
}
